import { useNavigate, useParams, useSearch } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Package } from "@/components/icons";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
  Skeleton,
} from "@/components/kit";
import { useProductQuery } from "../api/queries";
import { ProductFormPageHeader } from "../ui/ProductFormPageHeader";
import { ProductFormSection } from "../ui/ProductFormSection";
import { ProductStockPanel } from "../ui/ProductStockPanel";

export function ProductStockPage() {
  const { id } = useParams({ from: "/app/products/$id/stock" });
  const search = useSearch({ from: "/app/products/$id/stock" });
  const nav = useNavigate({ from: "/app/products/$id/stock" });
  const product = useProductQuery(id);

  const initialAssignVariantId =
    search.assign && search.variantId ? search.variantId : undefined;

  function clearAssignSearch() {
    if (!search.variantId && !search.assign) return;
    nav({
      search: { variantId: undefined, assign: undefined },
      replace: true,
    });
  }

  if (product.isLoading) {
    return (
      <>
        <Header />
        <Main className="flex flex-col gap-4">
          <Skeleton className="h-10 w-56 rounded-lg" />
          <Skeleton className="h-32 w-full rounded-2xl" />
          <Skeleton className="h-64 w-full rounded-2xl" />
        </Main>
      </>
    );
  }

  if (!product.data) {
    return (
      <>
        <Header />
        <Main>
          <div className="brand-card p-8">
            <Empty>
              <EmptyHeader>
                <EmptyTitle>ບໍ່ພົບສິນຄ້າ</EmptyTitle>
                <EmptyDescription>ສິນຄ້າອາດຖືກລຶບ ຫຼື ID ບໍ່ຖືກຕ້ອງ</EmptyDescription>
              </EmptyHeader>
            </Empty>
          </div>
        </Main>
      </>
    );
  }

  const p = product.data;

  return (
    <>
      <Header />
      <Main>
        <ProductFormPageHeader
          title={p.name}
          subtitle="Lot & ສະຕັອກ — ພາບລວມຕໍ່ຕົວເລືອກ ແລະ lot ຕາມ FIFO"
          onBack={() => nav({ to: "/app/products/$id/edit", params: { id } })}
        />

        <ProductFormSection
          icon={Package}
          title="ສະຕັອກ & Lot"
          description="ພາບລວມສະຕັອກແຕ່ລະຕົວເລືອກ — ກົດເບິ່ງ lot ເມື່ອຕ້ອງການ (FIFO)"
        >
          <ProductStockPanel
            product={p}
            initialAssignVariantId={initialAssignVariantId}
            onAssignDialogOpened={clearAssignSearch}
            onStockAdjusted={() => product.refetch()}
          />
        </ProductFormSection>
      </Main>
    </>
  );
}
